module.exports = __webpack_public_path__ + "static/img/Group 11119.3cb6479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Group 11119.png
// module id = YTep
// module chunks = 1